"use client";
import Image from "next/image";
import React from "react";
import FoodJarBanner from "../../../public/assets/background/food-jar_banner.webp";
import { IoCaretForward } from "react-icons/io5";
import CtbBanner from "../../../public/assets/background/why-jar-bg.jpg";
import JarImg from "../../../public/assets/background/jarbg.jpg";
import Link from "next/link";

import { HiHome } from "react-icons/hi2";
import { BsPatchCheckFill } from "react-icons/bs";
import MoreToExploreMobile from "@/components/product/ExploreMoreMobile";
import MoreToExplore from "@/components/product/ExploreMore";
import FoodClients from "@/components/product/foodClients/FoodClients";
import FoodClientsMobile from "@/components/product/foodClients/FoodClientsMobile";

const FlatGlass = () => {
  return (
    <>
      <section className="relative ">
        <div className="grid grid-cols-1 xl:mt-17 ">
          <Image
            src={FoodJarBanner}
            alt="Food Jar"
            className="w-full h-full"
            priority={true}
          />
        </div>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 bg-white rounded-ss-lg rounded-se-lg px-5 py-2 -mb-2">
          <ul className="flex items-center gap-2 p-2 ">
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm gap-1 text-red-600"
              >
                <HiHome />
                Home
              </Link>
            </li>
            <li className="text-sm text-gray-600">/</li>
            <li>
              <Link
                href=""
                className="flex items-center font-medium text-sm text-gray-400"
              >
                Food Jar
              </Link>
            </li>
          </ul>
        </div>
      </section>
      <h1 className="sr-only">Food Jar</h1>

      <section className="py-[50px] px-6 xl:mb-5 mb-0">
        <div className="container mx-auto">
          <div className="grid  xl:grid-cols-2  grid-cols-1 gap-5 items-center transition ease-in-out duration-500">
            <div>
              <h2 className="title !text-[#033b6f] !mb-0">
                Safe & <span className="text-[#d42427]"> Reliable Glass </span>
                Packaging
              </h2>
              <h5 className="text-xl  font-semibold">for food products</h5>

              <div className="pt-5">
                <p className="text-gray-700 text-sm md:text-base leading-relaxed text-justify mb-3">
                  Food deserves packaging that is not only{" "}
                  <strong>durable and functional</strong> but also{" "}
                  <strong>safe and hygienic</strong>. At{" "}
                  <strong>Emerge Glass</strong>, we manufacture a wide variety
                  of <strong>transparent food jars and bottles</strong> that
                  keep edibles fresh while showcasing their natural appeal.
                </p>
                <p className="text-gray-700 text-sm md:text-base leading-relaxed text-justify mb-3">
                  Our jars are designed for everyday use as well as large-scale
                  food brands, making them the ideal choice for sauces, pickles,
                  honey, and more.
                </p>
              </div>
            </div>

            <div className="">
              <video
                src="https://www.emergeglass.in/food-jar.mp4"
                className="rounded-lg"
                autoPlay
                muted
                loop
                playsInline
              ></video>
            </div>
          </div>
        </div>
      </section>
      <section className="xl:py-[80px] !pt-[20px] pb-[50px] px-6">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-6 items-center gap-6">
            <div className="order-1 lg:order-2 bg-gradient-to-b from-red-50 to-blue-50 p-6 md:p-8 shadow-2xl h-auto lg:h-[80%] lg:col-span-3 relative z-40 lg:-ml-[20%] rounded-lg border-b-4 border-red-400">
              <h2 className="title !text-[#033b6f] !text-center !text-2xl">
                Our <span className="text-[#d42427]"> Food Glass </span>
                Range
              </h2>

              <ul className="flex flex-col gap-4 text-sm md:text-base text-gray-700 leading-relaxed">
                <li className="flex items-center gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Transparent Sauce Jars –
                    </span>
                    <span className="text-[#003049] font-semibold text-sm">
                      {" "}
                      Durable jars for chutneys, spreads, and condiments.
                    </span>
                  </p>
                </li>

                <li className="flex items-center gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Ketchup Bottles –
                    </span>
                    <span className="text-[#003049] font-semibold text-sm">
                      {" "}
                      Classic designs with strong sealing properties
                    </span>
                  </p>
                </li>

                <li className="flex items-center gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Honey Jars –
                    </span>
                    <span className="text-[#003049] font-semibold text-sm">
                      {" "}
                      Clear glass packaging to highlight purity and quality
                    </span>
                  </p>
                </li>

                <li className="flex items-center gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Pickle & Preservative Jars –
                    </span>
                    <span className="text-[#003049] font-semibold text-sm">
                      {" "}
                      Reliable storage for long shelf life
                    </span>
                  </p>
                </li>

                <li className="flex items-center gap-2">
                  <span className="bg-white grid place-items-center w-5 h-5 rounded text-red-400 text-xs">
                    <IoCaretForward />
                  </span>
                  <p>
                    <span className="font-semibold text-red-500 text-base">
                      Custom Shapes & Sizes –
                    </span>
                    <span className="text-[#003049] font-semibold text-sm">
                      {" "}
                      Available for unique brand needs
                    </span>
                  </p>
                </li>
              </ul>
            </div>

            {/* Image Section (comes second on mobile/tablet) */}
            <Image
              src={JarImg}
              alt="factory image"
              loading="lazy"
              className="order-2 lg:order-1 rounded-lg relative z-10 w-full h-auto lg:col-span-3"
            />
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden ">
        <Image
          src={CtbBanner}
          alt="call to action banner"
          className="w-full h-[600px]  object-cover"
          loading="lazy"
        />

        <div className="absolute inset-0 bg-black/60 z-10"></div>

        <div className="absolute inset-0 md:w-full w-[92%] md:left-0 left-1/2 md:translate-x-0 -translate-x-1/2 flex items-start justify-center z-20 flex-col container mx-auto px-6">
          <h2 className="xl:text-4xl text-2xl font-bold text-left text-[#fff] mb-5">
            Why Choose Emerge Glass{" "}
            <span className="text-red-400">Food Jars?</span>
          </h2>

          <ul className="mt-5 flex flex-wrap justify-center gap-4 text-gray-300 xl:w-[60%]  ">
            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 xl:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Food-Safe Packaging
                </span>
                <br />
                Non-toxic, 100% safe for consumables
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 xl:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">
                  Clarity & Freshness
                </span>
                <br />
                Transparent glass enhances shelf appeal
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 xl:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">Durability </span>
                <br />
                Strong enough for storage and transport
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 xl:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">Eco-Friendly</span>
                <br />
                Fully recyclable and sustainable packaging solution
              </p>
            </li>

            <li className="flex items-center gap-2 bg-white/10 rounded-lg p-2 xl:w-[45%] w-full">
              <p className="grid place-items-center w-4 h-4 rounded text-red-400 text-sm">
                <BsPatchCheckFill />
              </p>
              <p className="text-xs text-white font-medium ">
                <span className="text-sm text-red-400">Variety of Options</span>
                <br />
                Multiple designs and capacities to match product requirements
              </p>
            </li>
          </ul>
        </div>
      </section>
      <section className=" relative bg-gradient-to-b from-white to-[#fbf9f5]">
        <FoodClients />
        <FoodClientsMobile />
      </section>

      <section className=" py-[50px] xl:pb-[100px] px-4 md:px-0 relative bg-gradient-to-b from-gray-800 to-[#fbf9f5]">
        <div className="">
          <h2 className="title !text-[#fff] !mb-5 !text-center">
            Explore <span className="text-[#d42427]"> More </span>
            Products
          </h2>

          <MoreToExplore />
          <MoreToExploreMobile />
        </div>
      </section>

      {/* <section className=" bg-[url(../../public/assets/background/bg_factory.png)] bg-cover bg-center">
        <div className="container mx-auto">
          <div className="grid grid-cols-1">
            <Image src={GlassImg} alt="factory image" loading="lazy" />
              <div className="bg-white min-h-[80vh] p-5 border-t-4 border-white border ">
            <ul className="flex flex-col gap-4 text-sm text-gray-700 leading-relaxed">
              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    Installed Capacity
                  </span>
                  <span className="text-red-500 font-semibold text-base">
                    {" "}
                    210 Ton/Day
                  </span>
                </p>
              </li>

              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    Packed Tonnage
                  </span>

                  <span className="text-red-500 font-semibold text-base">
                    {" "}
                    180 Ton/Day
                  </span>
                </p>
              </li>

              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    IS Machine:
                  </span>
                  Brand new machine from Sanjin
                  <span className="italic"> [Bucher Emhart Glass]</span>,
                  designed to produce
                  <span className="font-semibold">
                    {" "}
                    210 tons of high-quality container glass per day
                  </span>
                  for Narrow Neck bottles and Wide Mouth Jars.
                </p>
              </li>

              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    Manufacturing:
                  </span>
                  Container glass production across three categories — from
                  design to production — including ornamentation of premium
                  glass containers.
                </p>
              </li>

              <li className="flex items-center gap-2">
                <span className="bg-white grid place-items-center w-4 h-4 rounded text-red-400 text-xs">
                  <IoCaretForward />
                </span>
                <p>
                  <span className="font-semibold text-[#003049]">
                    Innovation:
                  </span>
                  Pioneering ultra-thin glass production in India, setting
                  superior benchmarks and creating value not only for ourselves
                  but also for the industry.
                </p>
              </li>
            </ul>
          </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default FlatGlass;
